module.exports = __webpack_public_path__ + "static/img/5.5612ffa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/5.png
// module id = 5gH/
// module chunks = 0